"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleUpdatePrintableGroupOrder;
const either_1 = require("../../../types/either");
const UpdatePrintableGroupOrder_1 = require("../../../actions/UpdatePrintableGroupOrder");
const updatePrintableGroupOrder_1 = require("../updatePrintableGroupOrder");
const updateProjectVersion_1 = __importDefault(require("../updateProjectVersion"));
function handleUpdatePrintableGroupOrder(project, action) {
  if (!(0, UpdatePrintableGroupOrder_1.isUpdatePrintableGroupOrder)(action)) {
    return (0, either_1.left)(new Error('Action does not match update ack empty printable schema'));
  }
  const newProject = (0, updateProjectVersion_1.default)(project, action);
  const updatePrintableGroupOrderResult = (0, updatePrintableGroupOrder_1.updatePrintableGroupOrder)(newProject, action);
  if (updatePrintableGroupOrderResult.isLeft()) {
    return (0, either_1.left)(updatePrintableGroupOrderResult.value);
  }
  return (0, either_1.right)({
    updatedProject: updatePrintableGroupOrderResult.value,
    updatedEntities: [updatePrintableGroupOrderResult.value]
  });
}